import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { canAccessPath, getLandingPath } from 'utils/roleAccess';

const ProtectedRoute = ({ component: Component, ...rest }) => {
  const location = useLocation();
  const token = localStorage.getItem('token');
  const userRole = localStorage.getItem('role');

  if (!token) {
    return <Navigate to="/login" />;
  }

  if (userRole !== 'superAdmin' && location.pathname === '/admins') {
    return <Navigate to="/unauthorized" />;
  }

  // Limited roles (e.g. supportAgent): block URLs outside Harvest Roles Matrix
  if (userRole && !canAccessPath(userRole, location.pathname)) {
    return <Navigate to={getLandingPath(userRole)} replace />;
  }

  return <Component {...rest} />;
};

export default ProtectedRoute;
